<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"
  title="{{ this.dossierItem.clientName }}"
>
  <snelstart-ui-details-content>
    <snelstart-venture-fiscaal-feature-tasks-item [id]="id"></snelstart-venture-fiscaal-feature-tasks-item>
  </snelstart-ui-details-content>

</snelstart-ui-details>
